(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click',event=>{const link=event.target.closest('.mobile-menu a');if(link)link.closest('details').open=false;});
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.mobile-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('change',event=>{if(event.target.matches('[data-variant-select]')){const url=new URL(window.location.href);url.searchParams.set('variant',event.target.value);window.location.assign(url.toString());}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-experience"]) return;
  try {
    
  document.addEventListener('change',event=>{if(event.target.matches('[data-product-variant]')){const url=new URL(window.location.href);url.searchParams.set('variant',event.target.value);window.location.assign(url.toString());}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["showroom-v2"] && !Shopify.designMode) return;
  try {
    
  (()=>{const items=document.querySelectorAll('.sh2-reveal');if(!items.length)return;if(!('IntersectionObserver' in window)){items.forEach(el=>el.classList.add('is-in'));return}const io=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-in');io.unobserve(entry.target)}})},{threshold:.18});items.forEach(el=>io.observe(el))})();

  } catch(e) { console.error(e); }
})();
})();
